<template>
  <div>
    <el-form-item :label="labelText(zdItem.label)" v-show="zdItem.display">
      <el-autocomplete
            v-model="zdFormattedValue"
            :fetch-suggestions="querySearch"
            @select="blurHandle"
            @blur="blurHandle"
            @change="inputChange"
            :disabled="setupDisable()"
            :placeholder="$t('view.placeholder')"
            style="width: 100%"
          >
        <template slot="append" v-if="zdItem.label == 'Item Code'"> <el-button :disabled="getAuthShow()" type="primary" style="color: #409EFF;"  circle @click="loadSpecInfoByItemCode(zdItem.value)"> Import For Spec</el-button></template>
        <!-- 如果有提示信息，则显示默认值按钮 -->
        <template v-if="zdItem.tips_value" #suffix>
          <el-popover
            placement="top-start"
            :content="getTipsValue()"
            trigger="hover"
            class="text-center"
          >
            <el-button
              slot="reference"
              icon="el-icon-edit"
              size="small"
              type="primary"
              :disabled="zdItem.disabled"
              @click="defaultValueHandle(zdItem.tips_value)"
            >
              {{ $t("action.default") }}
            </el-button>
          </el-popover>
        </template>
      </el-autocomplete>
    </el-form-item>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiServer } from "@/network/modules/detail-api";
import { EventBus } from "@/views/NEW/module/spec/config/eventBus";
import base from "@/common/base.js";
export default {
  name: "ZDAutoInput", // 设置组件名称为 ZDInput
  props: {
    // 组件的唯一 ID，用于在 Vuex 中标识和管理其状态
    zdId: {
      type: String,
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  inject: ["setItemCodeDataMethod"],
  computed: {
    // 从 Vuex 获取当前组件的整个状态
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    // 获取当前组件的状态对象
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    // 从状态对象中获取各个字段
    zdItem() {
      return this.zdComponentState;
    },
    labelText() {
      return (label) => {
        // console.info('this.zdItem:',this.zdItem)
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    getTipsValue() {
      return () => {
        let tips_value = this.zdItem.tips_value;

        let shelfLifeNumberId = "tab1_shelflife_number_id_input_0";
        let shelfLifeNumberValue =
          this.zdGetComponentState(shelfLifeNumberId).value || "";
        tips_value = tips_value.replace(
          "${other_notes.shelflife_number}",
          shelfLifeNumberValue
        );
        return tips_value;
      };
    },
    zdFormattedValue: {
      get() {
        let val = "";
        if (Array.isArray(this.zdItem.value)) {
          val = this.zdItem.value.join(",");
        } else {
          val = this.zdItem.value.toString() || "";
        }
        return val; // 获取输入框的值
      },
      set(value) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        }); // 更新输入框的值
      },
    },
  },
  data() {
    return {
      checkItemCode: false,
      checkItemCodeLoading: false,
      itemCodeStatusText: "",
      restaurants: [],
    };
  },
  created() {
    if (
      typeof this.zdItem.value === "boolean" ||
      Array.isArray(this.zdItem.value)
    ) {
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: this.zdItem.value.toString(),
      });
    }

    this.setupShelfLife(" ");
    this.loadItemCodeList();
    this.loadAppearanceInfo();
  },

  methods: {
    // 映射 Vuex 的动作
    ...mapActions("zdInput", ["updateComponent"]),
    zdUpdateComponent(payload) {
      this.updateComponent(payload); // 更新组件状态
    },
    loadAppearanceInfo(){
      if(this.zdItem.label != "Appearance"){
        return;
      }

    },
    getAuthShow(){
      return base.getAuthShow();
    },
    loadSpecInfoByItemCode(itemCode){
      // console.info("[DEBUG] loadSpecInfoByItemCode called with itemCode:",itemCode)
      // console.info("[DEBUG] Current environment:", process.env.NODE_ENV)
      // console.info("[DEBUG] API Base URL:", process.env.VUE_APP_API_BASE_URL)
      console.info("[DEBUG] EventBus emit setupSpecInfoByItemCode")
      EventBus.$emit("setupSpecInfoByItemCode", itemCode);
    },
    loadItemCodeList() {
      if (this.zdItem.label == "Item Code") {
        this.loadItemCodeListHandle();
      }else if(this.zdItem.label == "Appearance"){
        this.loadAppearanceInfoHandle();
      }

      
    },
    loadAppearanceInfoHandle(){
      let arr = this.zdItem.options_value.map(option => ({ value: option.label }))
      // console.info('loadAppearanceInfoHandle ===', arr);
      this.restaurants = arr;
    },
    loadItemCodeListHandle(){
      // const language = this.$route.query.language;
      // const storageKey = `itemCodeList_${language}`; // 移除 localStorage 使用
      // if(storedItemCodeList==null){ // 移除 localStorage 使用
        // 如果本地存储无效或解析失败,从服务器获取
        apiServer.getDataByType("spec", "getAuditedItemCodeList", {}, (res) => {
          const itemCodeList = res.map((obj) => ({ value: obj.itemCode }));
          this.restaurants = itemCodeList;
          // localStorage.setItem(storageKey, JSON.stringify(itemCodeList));
        });
      // }
    },
    querySearch(queryString, cb) {
      // console.info('querySearch ===', queryString);
      // console.info('this.restaurants:',this.restaurants)
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().includes(queryString.toLowerCase())
        );
      };
    },
    blurHandle(){
      
      if(this.zdItem.label != "Item Code"){
        return;
      }
      if(this.zdFormattedValue.length==0){
        return;
      }
      // 检查 itemCode 是否已经存在
      this.itemCodeStatusText = this.$t('confirm.item_code_checking');
      this.checkItemCode = true;
      this.checkItemCodeLoading = true;
      console.log('itemCode==:',this.zdItem.value)
      apiServer.getDataByType(
        "spec",
        "getDetailByItemCode",
        { "itemCode":this.zdItem.value},
        (res) => {
          this.checkItemCodeLoading = false;
          if (res.jsonValue) {
            this.itemCodeStatusText = this.$t('confirm.item_code_already_exists');
          } else {
            this.checkItemCode = false;
          }

        }
      );
    },
    inputChange(value) {
      this.setupItemCode();
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: value,
      }); // 更新输入框的值
      this.setupShelfLife(value);
    },
    setupShelfLife(value) {
      // 判断是否是 shelflife 的值
      if (this.zdItem.label == "Shelflife Number") {
        // 将shelflife_number保存到localStorage，以便ZDDate组件使用
        
        if (this.pageStatus === "Add") {
          let shelfLifeId = "tab1_shelf_life_id_input_1";
          let shelfLifeTipsValue =
            this.zdGetComponentState(shelfLifeId).tips_value || "";
          let val = shelfLifeTipsValue.replace(
            "${other_notes.shelflife_number}",
            value
          );
          this.zdUpdateComponent({
            id: shelfLifeId,
            field: "value",
            value: val,
          });
        }
      }
    },
    defaultValueHandle(value) {
      //获取已经存在的值
      let shelfLifeId = "tab1_shelflife_number_id_input_0";
      let shelfLifeTipsValue =
        this.zdGetComponentState(shelfLifeId).value || "";
      let val = value.replace(
        "${other_notes.shelflife_number}",
        shelfLifeTipsValue
      );
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: val,
      }); // 更新输入框的值
    },
    setupDisable() {
      if(this.getAuthShow()){
        return true;
      }
      let type = this.$route.query.type;
      if (type === "coa" && this.pageStatus === "Edit") {
        let tmpArr = [
          "product_name",
          "customer_product_name",
          "product_type",
          "ingredients",
          "country_of_origin",
        ];
        let key = this.zdItem.label.toLowerCase().replaceAll(" ", "_");
        if (tmpArr.includes(key)) {
          return true;
        }
      }
      return this.zdItem.disabled;
    },
    setupItemCode() {
      if (this.zdItem.label == "Item Code") {
        let type = this.$route.query.type;
        // 判断是否是 coa 类型
        if (type != "coa") {
          this.checkItemCode = true;
          this.checkItemCodeLoading = true;
          this.itemCodeStatusText = this.$t("confirm.item_code_checking");
          let itemCode = this.zdItem.value.trim();
          // console.info("itemCode:", itemCode);
          this.setItemCodeDataMethod(itemCode, (data) => {
            this.checkItemCodeLoading = false;
            if (data) {
              this.itemCodeStatusText = this.$t(
                "confirm.item_code_already_exists"
              );
            } else {
              this.checkItemCode = false;
            }
          });
        }
      }
    },
  },
};
</script>
